import SVG, { CustomSVGProps } from '@/src/components/common/SVG/SVG'

export default function SVGStar(props: CustomSVGProps) {
  return (
    <SVG width="44" height="42" viewBox="0 0 44 42" {...props}>
      <path
        d="M21.8745 0L28.9044 13.3242L43.7488 15.8926L33.2491 26.6958L35.3936 41.6074L21.8745 34.96L8.35545 41.6074L10.4999 26.6958L0.000211716 15.8926L14.8446 13.3242L21.8745 0Z"
        fill="#BFE6F7"
      />
    </SVG>
  )
}
